<template style="height: 100%">
  <article class="message menuCreateFrp">
    <div class="message-body" style="height: 100%">
      <div class="has-text-right">
        <button class="delete" aria-label="delete" v-on:click="close"></button>
      </div>
      <!-- First part -->
      <div class="has-text-centered">
        <!-- Title -->
        <div
          class="heading is-size-6 border"
          style="padding-top: 5px; margin-top: 5px; text-transform: capitalize;"
        >
          <!-- Text -->
          <div class="is-size-2">Crear Proceso</div>
        </div>
      </div>
      <br />
      <div class="box">
        <span class="is-size-7"
          >Los siguientes datos solicitados en el formulario se usará para
          construir el nombre del proceso. Ingresa la fecha correcta del
          proceso, con ello identificaremos los procesos más actualizados.</span
        >
      </div>
      <div style="margin-top: 25px;">
        <div>
          <label for="name"
            >Nombre del proceso<span class="has-text-dark has-text-weight-bold"
              >*</span
            ></label
          >
          <div class="field">
            <div class="control">
              <input
                class="input"
                :class="errors.name.type"
                v-model="process.name"
                type="text"
                id="name"
                name="name"
                placeholder="Nombre del nuevo proceso"
              />
            </div>
          </div>
          <span
            v-if="errors.name.message"
            class="is-size-7 has-text-danger"
            style="margin-top: -5px"
            >{{ errors.name.message }}</span
          >
        </div>
        <br />
        <div class="columns">
          <div class="column is-6">
            <label for="group"
              >Nombre del grupo<span class="has-text-dark has-text-weight-bold"
                >*</span
              ></label
            >
            <div class="field">
              <div class="control">
                <input
                  class="input"
                  :class="errors.group.type"
                  v-model="process.group"
                  type="text"
                  id="group"
                  name="group"
                  placeholder="Nombre del grupo"
                />
              </div>
            </div>
            <span
              v-if="errors.group.message"
              class="is-size-7 has-text-danger"
              style="margin-top: -5px"
              >{{ errors.group.message }}</span
            >
          </div>
          <div class="column is-6">
            <label for="created"
              >Fecha de creación<span class="has-text-dark has-text-weight-bold"
                >*</span
              ></label
            >
            <div class="field">
              <div class="control">
                <input
                  class="input"
                  :class="errors.created.type"
                  type="date"
                  v-model="process.created"
                  id="created"
                  name="created"
                  placeholder="Fecha de creación"
                />
              </div>
            </div>
            <span
              v-if="errors.created.message"
              class="is-size-7 has-text-danger"
              style="margin-top: -5px"
              >{{ errors.created.message }}</span
            >
          </div>
        </div>
        <div style="margin-top: 5px;">
          <div class="field">
            <div class="file is-link is-boxed has-name">
              <label class="file-label" style="width: 100% !important;">
                <input
                  ref="inputFile"
                  class="file-input"
                  type="file"
                  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                  name="data"
                  v-on:change="onFileChange"
                />
                <span class="file-cta">
                  <span class="file-icon">
                    <i class="material-icons">file_upload</i>
                  </span>
                  <span class="file-label">
                    Subir datos... {{ process._id ? "" : "*" }}
                  </span>
                </span>
                <span
                  class="file-name has-text-centered"
                  style="width: 100% !important; max-width: 100% !important"
                >
                  <span class="is-size-7">{{ file.name }}</span>
                </span>
              </label>
            </div>
            <span
              v-if="errors.data.message"
              class="is-size-7 has-text-danger"
              style="margin-top: -5px"
              >{{ errors.data.message }}</span
            >
          </div>
          <br />
          <label class="checkbox">
            <input
              class="is-medium is-dark"
              v-model="process.test"
              id="test"
              name="test"
              type="checkbox"
            />
            Es una prueba <br />(No se incluirá en datos para contexto)
          </label>
        </div>
        <div
          class="actions-footer has-background-white"
          style="position: absolute; bottom: 10px; width: 100%;"
        >
          <div class="is-flex">
            <button
              class="button is-danger is-outlined"
              style="margin-right: 5px"
              v-on:click="close"
            >
              Cancelar
            </button>
            <button class="button is-dark" v-on:click="createNewProcess">
              {{ process._id ? "Actualizar" : "Guardar" }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </article>
</template>

<script>
import apiServices from "@/services/yungol-services";
import templateXlsx from "@/assets/files/Estructura_de_datos_frsm.xlsx";

export default {
  data() {
    return {
      file: {
        name: "...",
        dataFile: null,
        filesAccept: [
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          "application/vnd.ms-excel",
        ],
        columnsValid: [
          // Bloque 03
          "RGO-03-Liderazgo",
          "RGO-03-Relaciones Sociales",
          "RGO-03-Retroalimentación",
          "RGO-03-Relación Colaboradores",
          // Bloque 04
          "RGO-04-Claridad de Rol",
          "RGO-04-Capacitación",
          "RGO-04-Participación y cambio",
          "RGO-04-Habilidades y conocimientos",
          "RGO-04-Control y Autonomía",
          // Bloque 05
          "RGO-05-Dem ambientales y fís",
          "RGO-05-Dem emocionales",
          "RGO-05-Dem cuantitativas",
          "RGO-05-Influencia trabajo entorno",
          "RGO-05-Exigencias cargo",
          "RGO-05-Demandas de carga mental",
          "RGO-05-Consistencia de Rol",
          "RGO-05-Dem Jornada de Trabajo",
          // Bloque 06
          "RGO-06-Recompensas del trabajo",
          "RGO-06-Reconocimiento",
          // Bloque 07
          "RGO-07-Tiempo Fuera del Trabajo",
          "RGO-07-Relaciones Familiares",
          "RGO-07-Comunicación",
          "RGO-07-Economía Familiar",
          "RGO-07-Vivienda",
          "RGO-07-Influencia Entorno Trabajo",
          "RGO-07-Desplazamiento",
          // Bloque 08
          "RGO-08-Optimismo",
          "RGO-08-Internalidad",
          "RGO-08-Autoestima",
          "RGO-08-Autoeficacia",
          // Bloque 10
          "RGO-10-Agotamiento Emocional",
          "RGO-10-Cinismo",
          "RGO-10-Pérdida de Autoeficacia",

          // Bloque Principal
          "RGO-02-TOTAL FRP INTRALABORALES",
          "RGO-03-LIDERAZGO Y RELACIONES SOCIALES EN EL TRABAJO",
          "RGO-04-CONTROL SOBRE EL TRABAJO",
          "RGO-05-DEMANDAS DEL TRABAJO",
          "RGO-06-RECOMPENSAS",
          "RGO-07-TOTAL FRP EXTRALABORALES",
          "RGO-08-INDICADOR CONDICIONES INDIVIDUALES",
          // Bloque
          "RGO-09-Engagement",
          "RGO-10-Burnout",
          "RGO-11-Estrés",
        ],
        urlTemplateXlsx: templateXlsx,
      },
      process: {
        name: "",
        group: "",
        data: null,
        created: null,
        test: false,
      },
      errors: {
        name: {},
        group: {},
        data: {},
        created: {},
      },
      errorsCont: 0,
    };
  },
  props: {
    data: Object,
  },
  methods: {
    close() {
      this.$emit("closeMenuCreate");
    },
    async createNewProcess() {
      const _this = this;
      const config = {
        title: "¿Estás seguro?",
        // text: "Se guardara un proceso ",
        icon: "warning",
        showCancelButton: true,
        cancelButtonColor: "#de5b5b",
        confirmButtonText: `Sí, ${this.process._id ? "actualizar" : "guardar"}`,
      };

      try {
        if (this.validateForm()) {
          this.$swal(config).then((result) => {
            if (result.isConfirmed) {
              const file = _this.file.dataFile;
              let task;
              if (file) {
                task = _this.$fire.refexcel(file);
                this.$store.dispatch("notify", {
                  message: "Cargando datos...",
                });
                task.on(
                  "state_changed",
                  () => {
                    // Cargador...
                  },
                  (err) => {
                    this.$store.dispatch("notify", {
                      message: "Error!. No se pudo subir los datos.",
                      type: "is-danger",
                    });
                    console.log("error subiendo el archivo", err);
                  },
                  async () => {
                    try {
                      const url = await task.snapshot.ref.getDownloadURL();
                      _this.process.data = url;
                      const data = {
                        name: `${_this.process.name} - ${
                          _this.process.group
                        } - ${_this.formatDateForName(_this.process.created)}`,
                        newProcess: _this.process,
                      };

                      if (url) {
                        await apiServices
                          .post(`/savefrp`, data)
                          .then(async (res) => {
                            if (res.data) {
                              _this.validateColumns(res.data.data);
                              await _this.$store.dispatch("notify", {
                                message: `Perfecto!. Proceso ${
                                  _this.process._id ? "Editado" : "Creado"
                                }.`,
                              });
                              _this.clearAllForm();
                              _this.$emit("getProcesses");
                              _this.close();
                            }
                          })
                          .catch(async (err) => {
                            this.$store.dispatch("notify", {
                              message: "Error!. No se pudo subir los datos.",
                              type: "is-danger",
                            });
                            console.log("Ocurrio un error: ", err);
                          });
                      } else {
                        this.$store.dispatch("notify", {
                          message: "Error!. No se pudo subir los datos.",
                          type: "is-danger",
                        });
                        console.log("Ocurrio un error: no se genero url");
                      }
                    } catch (err) {
                      this.$store.dispatch("notify", {
                        message: "Error!. No se pudo subir los datos.",
                        type: "is-danger",
                      });
                      console.log("Ocurrio un error: ", err);
                    }
                  }
                );
              } else {
                console.log("entro");
                const data = {
                  name: `${_this.process.name} - ${
                    _this.process.group
                  } - ${_this.formatDateForName(_this.process.created)}`,
                  newProcess: _this.process,
                };

                apiServices
                  .post(`/savefrp`, data)
                  .then(async (res) => {
                    if (res.data) {
                      _this.validateColumns(res.data.data);
                      await _this.$store.dispatch("notify", {
                        message: `Perfecto!. Proceso ${
                          _this.process._id ? "Editado" : "Creado"
                        }.`,
                      });
                      _this.clearAllForm();
                      _this.$emit("getProcesses");
                      _this.close();
                    }
                  })
                  .catch(async (err) => {
                    this.$store.dispatch("notify", {
                      message: "Error!. No se pudo subir los datos.",
                      type: "is-danger",
                    });
                    console.log("Ocurrio un error: ", err);
                  });
              }
            }
          });
        }
      } catch (err) {
        console.log(err);
      }
    },
    onFileChange(e) {
      const files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      if (!this.file.filesAccept.includes(files[0].type))
        return this.errorFile();
      this.file.dataFile = files[0];
      this.file.name = files[0].name;
      this.process.data = "cargando...";
    },
    validateForm() {
      this.errors = {
        name: {},
        group: {},
        data: {},
        created: {},
      };
      const process = this.process;
      let valid = true;
      if (process.name === "" || process.name === null) {
        this.errors.name.message = "El nombre es requerido.";
        this.errors.name.type = "is-danger";
        valid = false;
      }
      if (process.group === "" || process.group === null) {
        this.errors.group.message = "El grupo es requerido.";
        this.errors.group.type = "is-danger";
        valid = false;
      }
      if ((process.data === "" || process.data === null) && !this.process._id) {
        this.errors.data.message = "Los datos son requeridos.";
        this.errors.data.type = "is-danger";
        valid = false;
      }
      if (process.created === "" || process.created === null) {
        this.errors.created.message = "La fecha es requerida.";
        this.errors.created.type = "is-danger";
        valid = false;
      }
      if (!valid) {
        this.errorsCont++;
      }
      return valid;
    },
    validateColumns(data) {
      const errorColumns = [];
      const keys = Object.keys(data);

      for (const k of this.file.columnsValid) {
        if (!keys.includes(k)) errorColumns.push(k);
      }

      if (errorColumns.length) {
        const config = {
          title: "Datos guardados",
          html: `Al guardar se encontro errores en las columnas: <br/> <br/> ${errorColumns
            .toString()
            .replace(",", "<br/>")}`,
          icon: "warning",
        };

        this.$swal(config);
      }

      return errorColumns.length;
    },
    clearAllForm() {
      this.process = {
        name: "",
        group: "",
        data: null,
        created: null,
      };
      this.errors = {
        name: {},
        group: {},
        data: {},
        created: {},
      };
      this.errorsCont = 0;
    },
    errorFile() {
      this.$store.dispatch("notify", {
        message: `El archivo solo puede ser tipo Excel`,
        type: "is-danger",
      });
      this.deleteFile();
    },
    formatDateForName(d) {
      let date = new Date(d);
      date.setHours(date.getHours() + 12);
      let options = { day: "numeric", month: "long", year: "numeric" };
      date = date.toLocaleDateString(undefined, options);
      return date;
    },
  },
  created() {
    if (Object.keys(this.data).length) {
      const { id, nombre, created, test } = this.data;
      const [name, group] = nombre.split(" - ");
      this.process = {
        _id: id,
        name: name || "",
        group: group || "",
        data: null,
        created: created ? created.split("T")[0] : null,
        test: !!test,
      };
    }
  },
  watch: {
    process: {
      handler() {
        if (this.errorsCont) {
          this.validateForm();
        }
      },
      deep: true,
    },
  },
};
</script>
<style lang="scss">
.menuCreateFrp {
  @media screen and (max-width: 768px) {
    width: 100%;
  }
  @media screen and (min-width: 1280px) {
    width: 30%;
  }
  height: 100%;
  position: fixed;
  background: white;
  z-index: 251;
  top: 0;
  right: 0;
  overflow: scroll;
  border-radius: 0 0 0 0 !important;
}

.menuCreateFrp .actions-footer {
  @media screen and (max-width: 768px) {
    width: 100%;
  }
  @media screen and (min-width: 1280px) {
    width: 30%;
  }
}

.menuCreateFrp .field {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/frpm/components/menuCreateFrp.vue